var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticStyle: { top: "15%", height: "70%", "overflow-y": "hidden" },
      attrs: {
        title: _vm.title,
        width: _vm.modalWidth,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        maskClosable: false,
        footer: null,
        closable: false,
        cancelText: "",
      },
    },
    [
      _c(
        "div",
        [
          _c(
            "a-form",
            { attrs: { layout: "inline" } },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    {
                      staticStyle: { height: "150px", padding: "50px" },
                      attrs: { span: 24 },
                    },
                    [
                      _vm._v("\n          请使用新网址："),
                      _c(
                        "a",
                        {
                          staticStyle: { "text-decoration": "underline" },
                          attrs: {
                            href: "https://cloud.gyjerp.com",
                            target: "_blank",
                          },
                        },
                        [_vm._v("https://cloud.gyjerp.com")]
                      ),
                      _c(
                        "a",
                        {
                          staticStyle: {
                            "padding-left": "10px",
                            "font-weight": "bold",
                          },
                          attrs: {
                            href: "https://cloud.gyjerp.com",
                            target: "_blank",
                          },
                        },
                        [_vm._v("点击立即跳转")]
                      ),
                      _c("br"),
                      _c("br"),
                      _vm._v(
                        "\n          如有疑问请加微信：shenhua861584\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }